<div class="top-bar">
  <div class="content">
    <span (click)="goBack()">
      <img class="h-18" src="assets/images/icon/chevronleft.svg" />
      {{ translations['back_label'] }}
    </span>

    <span class="seperator"> </span>

    <span (click)="navigateHomePage()">
      <img src="assets/images/icon/refresh.svg" />
      {{ translations['restart'] }}
    </span>
  </div>
  <!-- <div class="content-start">
      </div> -->
  <!-- <div class="logo-div">
          <img src="assets/images/ecolab-logo-white-app-header.png" alt="EcoLab Logo" class="logo">
      </div> -->
  <div class="content-end">
    <select
      [value]="currentLanguage"
      (change)="languageChange($event)"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option.value === currentLanguage"
      >
        {{ option.value }}
      </option>
    </select>
  </div>
</div>
<main class="grow overflow-hidden">
  <div class="h-full min-h-0 border-b border-white">
    <div class="max-w-xl mx-auto pt-2 px-4">
      <div class="mb-4">
        <h1 class="sm:text-center">
          {{ translations['is_this_information_correct'] }}
        </h1>
      </div>
      <div class="mb-4">
        <label for="model-name">{{ translations['model_label'] }}</label>
        <input
          id="model-name"
          class="input-disable"
          type="text"
          name="model-name"
          [(ngModel)]="deviceData.selectedMachineType"
        />
      </div>
      <div class="mb-4">
        <label for="account-id">{{ translations['account_label'] }}</label>
        <input
          id="account-id"
          type="text"
          name="account-id"
          class="input-disable"
          [(ngModel)]="deviceData.accountName"
          readonly
        />
      </div>
      <div class="columns-2 mb-4">
        <div>
          <label for="state">{{ translations['state_label'] }}</label>
          <input
            id="state"
            type="text"
            name="state"
            class="input-disable"
            [(ngModel)]="deviceData.state"
            readonly
          />
        </div>
        <div>
          <label for="zip">{{ translations['zip_label'] }}</label>
          <input
            id="zip"
            type="text"
            name="zip"
            class="input-disable"
            [(ngModel)]="deviceData.zip"
            readonly
          />
        </div>
      </div>
      <div class="d-flex justify-content-center mb-4">
        <img
          class="img-machine"
          *ngIf="machineImageUrl"
          [src]="machineImageUrl"
        />
      </div>
    </div>
  </div>
</main>
<div class="layout-bottom">
  <div *ngIf="isBusinessHours" class="d-flex justify-content-center mx-4 mb-4">
    <p class="p">
      {{ translations['term3'] }}
      <span class="d-flex justify-content-center p">{{
        translations['term2']
      }}</span>
    </p>
  </div>
  <div *ngIf="!isBusinessHours" class="d-flex justify-content-center mx-4 mb-4">
    <p class="p">
      {{ translations['term1'] }}
      <span class="d-flex justify-content-center p">{{
        translations['term2']
      }}</span>
    </p>
  </div>
  <div class="max-w-xl mx-auto px-4 py-4 d-flex justify-content-center">
    <a
      *ngIf="!isBusinessHours"
      class="d-flex btn-blue-outline ms-1 justify-content-center a"
      href="tel:18003525326"
      (click)="navigate('contactUs')"
    >
      <img class="chatIcon" src="assets/images/icon/call.png" />
      <span class="ms-1 contact">
        {{ translations['call_ecolab'] }}
      </span>
    </a>
    <button
      *ngIf="isBusinessHours"
      class="btn-blue-outline ms-1"
      (click)="niceChat()"
    >
      <img class="chatIcon" src="assets/images/icon/chat.png" />
      <span class="ms-1">
        {{ translations['start_chat'] }}
      </span>
    </button>
  </div>
</div>
